import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Main.css";

import data from "../../data/data.json";
import Header from "../Header/Header";
import deliciousLogo from "../../assets/D100-logo.svg";
import FiltersAndViews from "../FiltersAndViews/FiltersAndViews";
import { useDispatch, useSelector } from "react-redux";
import ListSelector from "../ListSelector/ListSelector";
import Map from "../Map/Map";
import CategoryListing from "../CategoryListing/CategoryListing";
import DelOverlay from "../DelOverlay/DelOverlay";
import { setAllVotesForUser } from "../../redux/reducers/UserVoteReducer";
import LoginOverlay from "../LoginOverlay/LoginOverlay";

const Main = () => {
  const dispatch = useDispatch();

  const state = useSelector((state) => state.viewType);

  const [selectedLocations, setSelectedLocations] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [selectedCuisine, setSelectedCuisine] = useState([]);

  const [overlayPosition, setOverlayPosition] = useState(0);

  const [init, setInit] = useState(false);

  const getCookie = (name) => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + "=")) {
        return decodeURIComponent(cookie.substring(name.length + 1));
      }
    }
    return null;
  };

  const getAllVotesForUser = async () => {
    let rampartToken = getCookie("rampart_token");

    if (!rampartToken) {
      rampartToken = window.DNA_APP_ENV?.["rampart_token"];
    }

    const reqBody = {
      rampart_token: rampartToken,
      data: {
        state: "SA",
      },
    };

    const apiUrl =
      "https://tob6kguqgtiahokcjm7nyie4ca0pqhuj.lambda-url.ap-southeast-2.on.aws/";

    // Make the PUT request with a try...catch block
    try {
      const response = await axios.post(apiUrl, reqBody);

      if (response.status === 200) {
        const votedItems = response?.data?.body?.items;
        dispatch(setAllVotesForUser(votedItems));
      }
      // if (response.status === 403) {
      //   if (init) dispatch(setLoggedIn(false));
      //   // setIsLoggedIn(false);
      // }
    } catch (error) {
      // Handle any errors
      console.error("Delicious100 - Error posting a vote", error);
    }
  };

  useEffect(() => {
    if (!init) {
      setSelectedLocations(data?.[0]);
      // getAllVotesForUser();
    }

    setInit(true);
  }, [init]);

  return (
    <>
      {isLoggedIn && (
        <LoginOverlay
          // isLoggedIn={isLoggedIn}
          setIsLoggedIn={setIsLoggedIn}
        ></LoginOverlay>
      )}
      {isOpen && (
        <DelOverlay
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          deliciousData={selectedCuisine}
          overlayPosition={overlayPosition}
        ></DelOverlay>
      )}

      <div className="delicious100-interactive__main_body">
        <Header></Header>
        <img
          className="delicious100-interactive__main_logo"
          src={deliciousLogo}
          alt="deliciousLogo"
        ></img>
        <FiltersAndViews></FiltersAndViews>
        {state.currentViewType === "GRID_VIEW" ? (
          <CategoryListing
            data={data}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            setSelectedCuisine={setSelectedCuisine}
            setIsLoggedIn={setIsLoggedIn}
            setOverlayPosition={setOverlayPosition}
          ></CategoryListing>
        ) : (
          <div className="delicious100-interactive__main_grid_view">
            <ListSelector
              restaurantData={data}
              setSelectedLocations={setSelectedLocations}
            ></ListSelector>
            <Map
              selectedLocations={selectedLocations}
              setSelectedLocations={setSelectedLocations}
            ></Map>
          </div>
        )}
      </div>
    </>
  );
};

export default Main;
